import { render } from "./Responsive.vue?vue&type=template&id=6070c737&scoped=true"
import script from "./Responsive.vue?vue&type=script&lang=js"
export * from "./Responsive.vue?vue&type=script&lang=js"

import "./Responsive.vue?vue&type=style&index=0&id=6070c737&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6070c737"]])

export default __exports__